

<template>
  <div class="container" style="margin-top: 42px;">
    <el-row class="faq-container" style="padding:0 110px 48px 0;">
      <el-col v-for="(faq, index) in faqs" :key="index" :span="12">
        <div class="faq-item" @click="handleClick(faq)">
          <h3 class="show-ellipsis">{{ faq.question }}</h3>
            <div class="faq-answer show-ellipsis">
               <i>答</i> A: {{ faq.answer }}
            </div>
        </div>
      </el-col>
    </el-row>
  </div>

</template>
<script>

export default {
props:{
  activeName:{
    type:String
  }
},
components: {

},
created() {
 
},
data() {
  return {
    faqs: [
    {
      id:'1',
      question: '【退货换标】为什么仓库收到的数量和亚马逊后台退货的数量不同？',
      answer: '客观来说，亚马逊系统和人工也有可能出错，我们之前服务过两个客户，货物分别从亚马逊退到我们美国仓和英国仓，其中英国仓收到的箱子是有附带装箱清单的，但是仓库收到后马上开箱核对就发现少了一个。美国仓收到的没有清单，但是也同样比亚马逊后台纪录少了一个。因此仓库只能以实际收到的数量为准。'
    },
    {
      id:'2',
      question: '【退货换标】亚马逊后台申请移除订单，货物可能分几次退出，能不能先在仓库集齐货物再操作派送？',
      answer: '可以，我们仓库可以根据客户的要求，先接收货物，集齐所有货物再安排操作派送，帮卖家们节省成本。'
    },
   
    // 其他的FAQ对象...
  ]
  };
},
methods: {
  handleClick(item){
      console.log(item,this.activeName,'item,activeName')
      this.$router.push({
        path:'/questionDetail',
        query:{
          id:item.id,
          activeName:this.activeName
        }
      })
    }
}

};
</script>
<style src="../index.css" scoped>


</style>